import React from "react"
import { Flex } from "rebass"
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next"
import { ListItem } from "../checkout/ListItem"
import { BodyTextRegular, BodyTextSemibold } from "../typography/text"
import { css, useTheme } from "@emotion/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { getFormattedLanguage } from "../../util/languageUtil"
import { translationKeys } from "../../util/translationKeys"
import { DialogModal } from "../Dialog"

type Props = {
  isVisible: boolean
  hideModal: () => void
}

const getTitle = (title: string) => {
  const theme = useTheme()
  return (
    <BodyTextSemibold color={theme.colors.primary}>
      {getFormattedLanguage(title)}
    </BodyTextSemibold>
  )
}

export const LanguagePickerModal = ({ isVisible, hideModal }: Props) => {
  const { languages, changeLanguage, language } = useI18next()
  const theme = useTheme()
  const { t } = useTranslation()

  const onClick = (lang: string) => {
    changeLanguage(lang)
    hideModal()
  }

  const iconWrapper = css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    background-color: ${theme.colors.ctaLight};
  `

  return (
    <DialogModal
      title={`${t(translationKeys.webChooseLanguage)}`}
      isOpen={isVisible}
      onClose={hideModal}
    >
      <div className="flex flex-col gap-2 px-6 py-4">
        {languages
          .sort((a, b) => {
            if (a == language) {
              return -1
            } else if (b == language) {
              return 1
            } else {
              return a.localeCompare(b)
            }
          })
          .map((lang, index) => (
            <ListItem
              key={index}
              Title={getTitle(lang)}
              type="choose"
              onClick={() => onClick(lang)}
              Left={
                <Flex css={iconWrapper}>
                  <BodyTextSemibold color={theme.colors.ctaMain}>
                    <FontAwesomeIcon icon={solid("globe")} />
                  </BodyTextSemibold>
                </Flex>
              }
              Right={
                lang === language ? (
                  <BodyTextRegular color={theme.colors.primary}>
                    <FontAwesomeIcon icon={solid("check")} />
                  </BodyTextRegular>
                ) : (
                  <Flex className="choose-button">
                    <BodyTextRegular>
                      {t(translationKeys.webChoose)}
                    </BodyTextRegular>
                  </Flex>
                )
              }
            ></ListItem>
          ))}
      </div>
    </DialogModal>
  )
}
